const TextareaField = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  fullWidth = false,
  required = false,
  error,
}) => {
  return (
    <div className={`form-group ${fullWidth ? "full-width" : ""}`}>
      <label htmlFor={name}>
        {label}
        {required && <span> *</span>}
      </label>

      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        rows="3"
        required
        className={error ? "input-error" : ""}
      />

      {error && <small className="error-message">{error}</small>}
    </div>
  );
};

export default TextareaField;